import DocumentDirection from "./components/common/DocumentDirection";
import LandingRoutes from "./routes/LandingRoutes";
import "./App.css";

function LandingApp() {
  return (
    <div id="main" className="relative overflow-x-clip font">
      <DocumentDirection />
      <LandingRoutes />
    </div>
  );
}

export default LandingApp;
